var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"rgb(14,19,23)","fillRule":"evenodd","d":"M5.19282247 5.97782247c.460337.41481573 1.159663.41481573 1.62 0l4.4-4.19c.3877236-.39003745.3877236-1.01996254 0-1.41-.1877666-.18931265-.44336246-.29579832-.71-.29579832-.26663753 0-.5222334.10648567-.71.29579832l-3.67 3.46c-.09437656.08291147-.23562343.08291147-.33 0l-4.13-3.59C1.24584748-.11668545.61233042-.07415249.2478225.3428225c-.36450793.41697498-.321975 1.05049205.09499998 1.41499998l4.85 4.22z"}));
}

ChevronDown.defaultProps = {"width":"11.504","height":"6.289","viewBox":"0 0 11.504 6.289"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
